module.exports = __webpack_public_path__ + "images/category_lp/furniture/main-bg-sp_22eff945072b6361dd8862ec633e581c.jpg";